<template>
  <div class="about-wrapper">
    <container>
      <div class="about-header">
        <h2 class="about-header__title">On Media</h2>
        <p class="about-header__text">Holywoodskyline.com <span> is the sole promotional guide from the prestigious organizations of the film industry, which has received awards and success in various fields</span></p>
        <div class="about-header__img">
          <img src="@/assets/img/about/about-smile.svg" alt="">
        </div>

      </div>
    </container>

    <div class="about-info">
      <container>
        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/dom.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>350000</strong>
            <p>Movie record</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/student.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>4.510</strong>
            <p>Registered User</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/visitor.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>1.273.413</strong>
            <p>Annual Visitor</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>

        <div class="about-info__item">
          <div class="about-info__item_img">
            <img src="@/assets/img/about/view.svg" alt="">
          </div>
          <div class="about-info__number">
            <strong>4.233.502</strong>
            <p>Views</p>
          </div>
          <div class="about-info__item_text">
          </div>
        </div>
      </container>
    </div>

    <div class="media" id="media">
      <container>
        <div class="media__top">

        </div>
        <div class="section__header">
          <div class="section__title">
            <span class="color-light-green">On Media</span> HolywoodSkyline<span class="color-light-green">.com ?</span>
          </div>
        </div>
        <h1 class="media__title">Included in the news in many national press by taking it as a reference to the audience <br><br> " +
                "As Holywoodskyline.com, the film and TV series are at the forefront of all search engines worldwide "+
                 "We act as a bridge between content and viewers in their searches."</h1>
        <div class="media__list">

          <div class="blog-list__item" v-for="(media,index) in mediaList" :key="media.id" @click="dataGo(media,index)">
            <media-card :media="media"/>
          </div>

          <transition name="fade">
          <ImageLightBox :data="MediaArray" v-if="display" @closeLightBox="closeBox"
                         @onClickNext="nextNotice"
                         @onClickPrev="prevNotice"
          />
          </transition>

        </div>
      </container>
    </div>
  </div>
</template>

<script>
import MediaCard from '@/components/MediaCard'
import ImageLightBox from '@/components/ImageLightBox'

export default {
  name: 'About',
  components: {
    MediaCard, ImageLightBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'On Media',
      link: [
        { rel: 'canonical', href: window.location.origin + '/media' }
      ] 
    }
  },   
  data () {
    return {
      display: false,
      IndexNo: null,
      MediaArray: {},
      mediaList: [
        {
          id: 0,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5b4a9cc0eb10bb2434e7fb69.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 1,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'https://im.haberturk.com/2018/10/19/2183896_05967b8ab6f7a0a0e836443fcca7012b_640x640.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 2,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 3,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 4,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 5,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 6,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'Milliyet',
          author: 'Tom Hanks'
        },
        {
          id: 7,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 8,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        },
        {
          id: 9,
          cover: require('@/assets/img/networks/amc.png'),
          image: 'http://i.hurimg.com/i/hurriyet/75/0x0/5add304ceb10bb358050dfe0.jpg',
          date: '18 march 2018',
          title: 'American Movie Classics',
          author: 'Tom Hanks'
        }        
      ]
    }
  },

  methods: {
    dataGo (data, index) {
      this.display = true
      this.MediaArray = data
      this.IndexNo = index
    },
    closeBox () {
      this.display = false
    },
    nextNotice () {
      this.MediaArray = []
      this.IndexNo++
      this.MediaArray = this.mediaList[this.IndexNo]
    },

    prevNotice () {
      this.MediaArray = []
      this.IndexNo--
      this.MediaArray = this.mediaList[ this.IndexNo ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/about";
</style>
